"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentRegion = exports.isTestENV = exports.currentCid = exports.CidMap = void 0;
var url_1 = require("../url");
var utils_1 = require("./utils");
var originInfo = url_1.parseOrigin();
exports.CidMap = {
    id: 'co.id',
    my: 'com.my',
    th: 'co.th',
    sg: 'sg',
    ph: 'ph',
    vn: 'vn',
    tw: 'tw',
    br: 'com.br',
    mx: 'mx',
    co: 'com.co',
    cl: 'cl',
};
exports.currentCid = originInfo.cid;
exports.isTestENV = originInfo.env === 'test';
exports.currentRegion = utils_1.getRegionByCid(exports.currentCid); // 当前 region
